<main class="min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 flex items-center justify-center px-4">
  <div class="text-center max-w-sm w-full">

    <!-- 404 number -->
    <div class="relative inline-block mb-8">
      <p class="text-[160px] font-black text-white/10 leading-none select-none tracking-tighter">404</p>
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="w-24 h-24 bg-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center border border-white/20 shadow-xl">
          <svg class="w-12 h-12 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Message card -->
    <div class="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 shadow-xl">
      <h2 class="text-2xl font-bold text-white mb-2">Page Not Found</h2>
      <p class="text-sm text-white/60 leading-relaxed mb-6">
        This link doesn't exist or has already expired. Guarantor links are single-use and time-limited for security.
      </p>
      <div class="border-t border-white/10 pt-5">
        <p class="text-[11px] font-bold text-white/40 uppercase tracking-widest mb-2">Need help?</p>
        <p class="text-xs text-white/50 leading-relaxed">
          Contact the borrower and ask them to request a new link from
          <span class="text-white/70 font-semibold">Direct Savings &amp; Loans</span>.
        </p>
      </div>
    </div>

    <p class="text-center text-xs text-primary-300 mt-8">
      Powered by Direct Savings &amp; Loans
    </p>

  </div>
</main>
